<template>
    <div class="special_warpper">
        <MaskLoading v-if="isShow"></MaskLoading>
        <banner :bannerList="bannerList" :isMobile="isMobile"></banner>
        <!--  -->
        <div class="special_box">
            <!--  -->
            <div class="s_row">
                <div class="s_row_list">
                    <el-row :gutter="20" class="mb20">
                        <el-col :span="24">
                            <div class="">
                                <span class="title">普惠型保障</span>
                                <span class="desc">工会会员免费享受</span>
                            </div>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20" class="mb20">

                        <el-col :span="12" v-for="(item, index) in PHList" :key="index">
                            <img :src="baseUrl + (isMobile ? item.ImgSrc : item.PcImgSrc)" alt="" class="ph_img"
                                @click="nav(item.Link)">
                        </el-col>
                    </el-row>
                </div>
                <!--  -->
                <div class="s_row_list">
                    <!--  -->
                    <el-row :gutter="20" class="mb20">
                        <el-col :span="24">
                            <div class="">
                                <span class="title">会费型保障</span>
                                <span class="desc">需所属单位工会申请参保</span>
                            </div>
                        </el-col>
                    </el-row>
                    <div class="hf_box mb10">
                        <img v-for="(item, index) in HFList" :key="index"
                            :src="baseUrl + (isMobile ? item.ImgSrc : item.PcImgSrc)" alt="" class="hf_img"
                            @click="nav(item.Link)">
                    </div>
                </div>

                <!--  -->
            </div>
            <!--  -->
            <div class="s_row">
                <div class="s_row_list">
                    <el-row :gutter="20" class="mb20">
                        <el-col :span="24">
                            <div class="">
                                <span class="title">会员权益</span>
                                <span class="desc">温暖权益,职工专属</span>
                            </div>
                        </el-col>
                    </el-row>
                    <div class="vip mb20">
                        <img v-for="(item, index) in QYList" :key="index"
                            :src="baseUrl + (isMobile ? item.ImgSrc : item.PcImgSrc)" alt="" class="vip_img"
                            @click="nav(item.Link)">
                    </div>
                </div>
                <!--  -->
                <div class="s_row_list">
                    <el-row :gutter="20" class="mb20">
                        <el-col :span="24">
                            <div class="">
                                <span class="title">工会会员活动</span>
                                <span class="desc">工会福利，会员尽享</span>
                            </div>
                        </el-col>
                    </el-row>
                    <div class="vip mb20">
                        <img v-for="(item, index) in HYRList" :key="index"
                            :src="baseUrl + (isMobile ? item.ImgSrc : item.PcImgSrc)" alt="" class="vip_img cupo"
                            @click="nav(item.Link)">
                    </div>
                </div>
            </div>

            <!--  -->

            <!--  -->
            <el-row :gutter="20" class="mb20" v-if="HDList && HDList.length">
                <el-col :span="24">
                    <div class="">
                        <span class="title">往期活动</span>
                        <span class="desc">“京”选活动</span>
                    </div>
                </el-col>
            </el-row>
            <div class="activity">
                <img v-for="(item, index) in HDList" :key="index"
                    :src="baseUrl + (isMobile ? item.ImgSrc : item.PcImgSrc)" alt="" class="activity_img cupo"
                    @click="nav(item.Link)">
            </div>
            <!--  -->
        </div>

    </div>
</template>

<script>
import banner from "../../components/banner.vue"
import MaskLoading from "@/components/maskLoading.vue";
import Mixins from "../../script/getMobile";
import axios from 'axios'
export default {
    name: "special",
    mixins: [Mixins],
    data() {
        return {
            isShow: true,
            bannerList: [],
            PHList: [],
            HFList: [],
            QYList: [],
            HYRList: [],
            HDList: [],
        }
    },
    components: {
        banner,
        MaskLoading
    },
    created() {

    },
    mounted() {

        this.initFn();
    },
    methods: {
        initFn() {
            axios.all([
                this.$api.indexSwiper(),
                this.$api.indexPuHui(),
                this.$api.indexHuiFei(),
                this.$api.indexQuanYi(),
                this.$api.indexHuiYUanRi(),
				/*
					finished = 0   进行中 后台“工会活动入口管理”
					finished = 1   已完成 后台“工会会员活动入口管理”
					
				*/
                this.$api.indexHuoDong({"finished": 0}) 
				
                // eslint-disable-next-line no-unused-vars
            ]).then(axios.spread((res1, res2, res3, res4, res5, res6) => {
                this.bannerList = res1.resultBody;
                this.PHList = res2.resultBody;
                this.HFList = res3.resultBody;
                this.QYList = res4.resultBody;
                this.HYRList = res5.resultBody;
                this.HDList = res6.resultBody;
                setTimeout(() => {
                    this.isShow = false;
                }, 200)
            })).catch((e) => {
                console.log(e)

            })
        },
        nav(url) {
            if (url) {
                if (url.indexOf('http') > -1) {
                    location.href = url;
                } else {
                    this.$router.push(url)
                }
            }
        }
    }
}
</script>

<style lang="less" >
.special_warpper {
    background-color: #f8f8f8;

    .special_box {
        padding: 20px 20px;
        max-width: 1200px;
        margin: auto;

        .title {
            font-size: 18px;
            font-weight: bold;
            padding-right: 10px;
        }

        .desc {
            color: #9a9a9a;
        }

        .ph_img {
            width: 100%;
            display: block;
            border-radius: 25px;
        }

        .hf_img {
            width: 100%;
            display: block;
            border-radius: 15px;
        }

        .hf_box {
            display: flex;
            flex-wrap: wrap;
            margin-left: -5px;
            margin-right: -5px;

            .hf_img {
                width: calc(33.333% - 10px);
                margin-left: 5px;
                margin-right: 5px;
                margin-bottom: 10px;
                border-radius: 10px;
            }
        }

        .vip_img {
            width: 100%;
            display: block;
            border-radius: 25px;
        }

        .activity {
            display: flex;
            flex-wrap: wrap;

            .activity_img {
                width: 32%;
                display: block;
                margin-right: 2%;
                margin-bottom: 20px;
                border-radius: 20px;
                height: 100%;
                max-height: 256px;
            }

            .activity_img:nth-child(3n) {
                margin-right: 0%;
            }
        }



        @media screen and (max-width: 800px) {
            .ph_img {
                border-radius: 15px;
            }

            .vip_img {
                border-radius: 15px;
            }

            .activity {
                display: block;

                .activity_img {
                    width: 100%;
                    margin-right: 0;
                    border-radius: 15px;
                }
            }



        }
    }

    .s_row {
        display: flex;
        justify-content: space-between;

        .s_row_list {
            width: 48%;
            cursor: pointer;
        }
    }

    @media screen and (max-width: 800px) {
        .s_row {
            display: block;
            justify-content: space-between;

            .s_row_list {
                width: 100%;
            }
        }
    }
}
</style>